import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/nplogo.png'


const _withScopeId = n => (_pushScopeId("data-v-49ebe64f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-lg sticky-top fixed-top shadow navbar-light navbar-dark bg-dark" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "120",
  class: "align-middle mr-2 d-md-none d-xs-inline-block d-sm-inline-block"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "250",
  class: "align-middle mr-2 d-none d-md-inline-block"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_6 = {
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_7 = { class: "navbar-nav me-auto mb-2 mb-lg-0" }
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = {
  key: 0,
  class: "navbar-nav ms-auto"
}
const _hoisted_12 = { class: "nav-item nav-right" }
const _hoisted_13 = {
  key: 1,
  class: "navbar-nav ms-auto"
}
const _hoisted_14 = { class: "nav-item dropdown" }
const _hoisted_15 = {
  class: "nav-link dropdown-toggle",
  href: "#",
  id: "navbarDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_16 = {
  class: "dropdown-menu dropdown-menu-end",
  "aria-labelledby": "navbarDropdown"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_login_button = _resolveComponent("login-button")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "navbar-brand"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "/write",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Skriv för NP")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createVNode(_component_router_link, {
              to: "/advertisement",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Annonsera")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: "/tips",
              class: "nav-link"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Tipsa oss")
              ]),
              _: 1
            })
          ])
        ]),
        (!_ctx.isAuthed())
          ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
              _createElementVNode("li", _hoisted_12, [
                _createVNode(_component_login_button, { type: "link" })
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isAuthed())
          ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
              _createElementVNode("li", _hoisted_14, [
                _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.userName()), 1),
                _createElementVNode("ul", _hoisted_16, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: "/account/user/profile",
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Din profil")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "dropdown-item",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleAppMenu()))
                    }, "Visa/dölj funktioner")
                  ]),
                  _hoisted_17,
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: "#",
                      class: "dropdown-item",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logout()))
                    }, "Logga ut")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}